import { formatReportNumber } from '../../../../../features/formatters'

export const getOptions = (legendContainerId, currencySymbol) => {
  return {
    indexAxis: 'y',
    scales: {
      x: {
        stacked: true,
        ticks: {
          display: false
        },
        grid: {
          drawBorder: false,
          drawOnChartArea: true
        },
        border: {
          dash: [6, 6],
          display: false
        }
      },
      y: {
        stacked: true,
        ticks: {
          display: true,
          color: '#000',
          font: {
            size: 17,
            weight: 400
          }
        },
        grid: {
          display: false
        },
        border: {
          dash: [6, 6],
          display: true,
          color: '#000'
        }
      }
    },

    plugins: {
      legend: { display: false },
      htmlLegend: {
        // ID of the container to put the legend in
        containerID: legendContainerId
      },
      tooltip: {
        callbacks: {
          label: tooltipItem =>
            formatReportNumber({ value: tooltipItem.raw, format: 'currency', currency: currencySymbol })
        }
      }
    }
  }
}
